import { DumQueryApi } from '@src/Api/generated-global-event';
import { useStores } from '@src/Common/Hooks/useStores';
import AxiosInstanceGlobalEvent from '@src/Common/Services/Api/AxiosInstanceGlobalEvent';
import { AxiosInstance } from 'axios';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
const lDEQa = (AI: AxiosInstance) => new DumQueryApi(undefined, '', AI);
const useMySubmissionsDialog = () => {
  const { MySubmissionStore } = useStores();
  const { user, isLoading } = useAuth();
  const fetchDUMEvent = lDEQa(AxiosInstanceGlobalEvent(''));
  useEffect(() => {
    if (!isLoading) {
      MySubmissionStore.loadEvents(
        user?.profile.sub.toString() ?? '',
        fetchDUMEvent
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  return {};
};

export default useMySubmissionsDialog;
